import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { makeStyles } from '@material-ui/core/styles';

interface InputHintButtonProps {
  text: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  buttonContainer: {
    position: 'absolute',
    top: 8,
    right: -40,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
}));

const InputHintButton: React.FC<InputHintButtonProps> = ({ text, onClick, icon, children }) => {
  const classes = useStyles();

  const handleButtonClick = () => {
    onClick && onClick();
  };

  return (
    <div className={classes.root}>
      {children}
      <div className={classes.buttonContainer}>
        <Tooltip title={text}>
          {onClick ? (
            <IconButton size='small' onClick={handleButtonClick}>
              {icon || <PostAddIcon fontSize='small' />}
            </IconButton>
          ) : (
            <span>{icon || <PostAddIcon fontSize='small' />}</span>
          )}
        </Tooltip>
      </div>
    </div>
  );
};

export default InputHintButton;
